var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":""}})],1),_c('v-col',{attrs:{"cols":"12","align":"center"}},[_vm._v(" "+_vm._s("잠시만 기다려주세요")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }